// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HDvz","top":"styles_top__2wd8x"};